import { alpha, Box, Paper, Skeleton } from '@mui/material'

const TransparencyWidget = () => {
    return (
        <>
            <Paper
                elevation={0}
                sx={{
                    borderRadius: '12px',
                    border: '1px solid',
                    borderColor: 'borders.default',
                    mt: 2,
                    overflow: 'hidden'
                }}
            >
                {/* Header with tabs section */}
                <Box
                    sx={{
                        bgcolor: theme => alpha(theme.palette.primary.light, 0.2),
                        borderBottom: '1px solid',
                        borderColor: 'borders.default',
                        px: 2,
                        py: 1.5
                    }}
                >
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <Skeleton variant="rectangular" width={180} height={24} sx={{ borderRadius: 0.5 }} />
                        <Skeleton variant="rectangular" width={180} height={24} sx={{ borderRadius: 0.5 }} />
                    </Box>
                </Box>

                {/* Baggage and meal info section */}
                <Box
                    sx={{
                        display: 'flex',
                        gap: 2,
                        px: 3,
                        py: 2,
                        borderBottom: '1px solid',
                        borderColor: 'borders.default',
                        justifyContent: 'space-around'
                    }}
                >
                    {[1, 2, 3, 4].map(item => (
                        <Box key={item} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Skeleton variant="circular" width={18} height={18} />
                            <Skeleton variant="text" width={80} height={16} />
                        </Box>
                    ))}
                </Box>

                {/* Cancellation policy section */}
                <Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            px: 3,
                            py: 2
                        }}
                    >
                        <Skeleton variant="text" width={180} height={20} />
                        <Skeleton variant="circular" width={24} height={24} />
                    </Box>
                </Box>

                {/* Date change policy section */}
                <Box sx={{ borderTop: '1px solid', borderColor: 'borders.default' }}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            px: 3,
                            py: 2
                        }}
                    >
                        <Skeleton variant="text" width={150} height={20} />
                        <Skeleton variant="circular" width={24} height={24} />
                    </Box>
                </Box>
            </Paper>
        </>
    )
}

export default TransparencyWidget
